const contactTemplate =
  '<p/>' +
  '<p>#contato</p>' +
  '<p>Nome: </p>' +
  '<p>Telefone: </p>' +
  '<p>Email: </p>' +
  '<p">#fim</p>';

export { contactTemplate };
